export default "__VITE_ASSET__DCNYsf$C__"